import React, { HTMLProps, ReactNode, useMemo } from 'react';

import { makeClassNames } from '../../../utils/styles';

import './glider-item.scss';

export type GliderItemState = 'enabled' | 'focused' | 'disabled';

export const GLIDER_ITEM_STATE_ENABLED: GliderItemState = 'enabled';
export const GLIDER_ITEM_STATE_DISABLED: GliderItemState = 'disabled';
export const GLIDER_ITEM_STATE_FOCUSED: GliderItemState = 'focused';

const classNames = () =>
  makeClassNames({
    gliderItem: 'g-item',
    gliderAnchor: 'g-item__anchor',
  });

export interface IGliderItem {
  onItemSelectedCallback?: (id: number) => any;
  href?: string;
  id?: number;
  itemState?: GliderItemState;
  label: ReactNode;
}

interface CtaProps extends HTMLProps<HTMLAnchorElement> {
  'data-state'?: string;
  'data-id'?: string | number;
}

// TODO: LC 2020-07-20 - I can't use JS FUNCTION DEFAULT VALUES because they are REQUIRED in both TS INTERFACE and REACT PROPTYPES!
// To preserve CODE COVERAGE I use the ugly "istanbul ignore next" statement (including CALLBACK, can't set a spy on default value)
const GliderItem = ({
  /* istanbul ignore next: default value on mandatory field */ onItemSelectedCallback = () => {},
  href,
  id,
  itemState = GLIDER_ITEM_STATE_ENABLED,
  label,
}: IGliderItem) => {
  const cn = classNames();

  const anchorProps = useMemo(() => {
    const props: CtaProps = {
      className: cn.gliderAnchor,
      id: `glider-item-a${id}`,
      'data-state': itemState,
      'data-id': id,
      onClick: () => (id ? onItemSelectedCallback(id) : {}),
    };

    if (href) {
      props.href = href;
    }

    return props;
  }, [cn, id, itemState, href, onItemSelectedCallback]);

  return (
    <div className={cn.gliderItem} data-id={id} data-state={itemState}>
      <a {...anchorProps}>{label}</a>
    </div>
  );
};

export default GliderItem;
